$(function () {
    $(".filtar-bar__desk-wrap").on("click", function (e) {
        e.stopPropagation();
        $(".filtar-bar__desk-list").not($(this).find(".filtar-bar__desk-list")).slideUp(200);
        $(this).find(".filtar-bar__desk-list").slideToggle(200);
    });

    $(".filtar-bar__desk-list-link").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation(); // 🧠
        const txt = $(this).text();
        const $wrap = $(this).closest(".filtar-bar__desk-wrap");
        $wrap.find(".filtar-bar__desk-selected").text(txt);
        $wrap.find(".filtar-bar__desk-list").slideUp(200);
    });

    $(document).on("click", () => $(".filtar-bar__desk-list").slideUp(200));
});




$(function () {

    const isMobile = () => $(window).width() <= 1024;


    $(".filtar-bar__btn-content").on("click", function (e) {
        e.stopPropagation();
        const $sel = $(this).closest(".filtar-bar__selection");


        if (isMobile()) {
            $(".filtar-bar__selection").not($sel)
                .removeClass("active")
                .find(".filtar-bar__list").slideUp(200);

            $sel.toggleClass("active")
                .find(".filtar-bar__list").stop(true, true).slideToggle(200);
        } else {

            $(".filtar-bar__selection").not($sel).removeClass("active");
            $sel.toggleClass("active");
        }
    });


    $(".filtar-bar__item-link").on("click", function (e) {
        e.preventDefault();

        const $this = $(this);
        const $sel = $this.closest(".filtar-bar__selection");

        $this.closest(".filtar-bar__items")
            .find(".filtar-bar__item-link").removeClass("active");
        $this.addClass("active");

        $sel.find(".filtar-bar__btn p").text($this.text());

        if (isMobile()) {
            $sel.removeClass("active").find(".filtar-bar__list").slideUp(200);
        } else {
            $sel.removeClass("active");
        }
    });

    $(document).on("click", e => {
        if (isMobile() && !$(e.target).closest(".filtar-bar__selection").length) {
            $(".filtar-bar__selection")
                .removeClass("active")
                .find(".filtar-bar__list").slideUp(200);
        }
    });


    $(window).on("resize", () => {
        if (!isMobile()) {
            $(".filtar-bar__selection.concern")
                .removeClass("active")
                .find(".filtar-bar__list").hide();
        }
    });

});



//Sort js code for desktop
document.addEventListener("DOMContentLoaded", function () {
    const sortWrap = document.querySelector(".filtar-bar__desk-wrap");
    const selectedText = document.querySelector(".filtar-bar__desk-selected");
    const sortList = document.querySelector(".filtar-bar__desk-list");
    const sortLinks = document.querySelectorAll(".filtar-bar__desk-list-link");

    if (!sortWrap || !selectedText || !sortList) return;

    // oggle dropdown visibility
    sortWrap.addEventListener("click", function (e) {
        // Only toggle when clicking outside actual link
        if (!e.target.classList.contains("filtar-bar__desk-list-link")) {
            sortList.classList.toggle("active");
        }
    });

    // 🔹 Update selected text + close dropdown
    sortLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            const url = this.getAttribute("href");
            const name = this.textContent.trim();

            // Update visible text
            selectedText.textContent = name;

            // Close dropdown
            sortList.classList.remove("active");

            // Optional: visually mark active link
            sortLinks.forEach(l => l.classList.remove("active"));
            this.classList.add("active");

            // Redirect (Shopify handles sorting automatically)
            window.location.href = url;
        });
    });

    // Close dropdown if clicked outside
    document.addEventListener("click", function (e) {
        if (!sortWrap.contains(e.target)) {
            sortList.classList.remove("active");
        }
    });

    //  Show current active sort on load
    const params = new URLSearchParams(window.location.search);
    const currentSort = params.get("sort_by");
    if (currentSort) {
        const currentLink = document.querySelector(
            `.filtar-bar__desk-list-link[href*="${currentSort}"]`
        );
        if (currentLink) {
            selectedText.textContent = currentLink.textContent.trim();
            currentLink.classList.add("active");
        }
    }
});



//Sort js code for mobile
document.addEventListener("DOMContentLoaded", () => {
  const sortButton = document.querySelector(".filtar-bar__btn-content");
  const sortList = document.querySelector(".filtar-bar__list");
  const sortItems = document.querySelectorAll(".filtar-bar__item-link a");

  // Toggle sort dropdown
  if (sortButton && sortList) {
    sortButton.addEventListener("click", () => {
      sortList.classList.toggle("active");
    });

    // Close list when clicking outside
    document.addEventListener("click", (e) => {
      if (!sortButton.contains(e.target) && !sortList.contains(e.target)) {
        sortList.classList.remove("active");
      }
    });
  }

  // Handle sort click
  sortItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const sortUrl = e.target.getAttribute("href");

      // Optional: visually show active state
      sortItems.forEach((i) => i.classList.remove("active"));
      e.target.classList.add("active");

      // Redirect with selected sort
      window.location.href = sortUrl;
    });
  });
});



// collection tag tab
$(document).ready(function() {
  $('.tag-filter__btn').on('click', function(e) {
    e.preventDefault();
    const selectedTag = $(this).data('tag');

    // Update active state
    $('.tag-filter__btn').removeClass('active');
    $(this).addClass('active');

    // Filter products
    $('.grid-product').each(function() {
      const tags = $(this).data('tags');
      if (selectedTag === 'all' || (tags && tags.includes(selectedTag))) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
});
